module.exports = __webpack_public_path__ + "static/media/clown.5c1549fe.png";